import React from 'react';
import PropTypes from 'prop-types';

const BarChartSquare03Icon = ({color = 'currentColor', ...props}) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M13.9999 14V9M9.99988 14V6M5.99988 14V12M3.99988 18C2.89531 18 1.99988 17.1046 1.99988 16V4C1.99988 2.89543 2.89531 2 3.99988 2H15.9999C17.1044 2 17.9999 2.89543 17.9999 4V16C17.9999 17.1046 17.1044 18 15.9999 18H3.99988Z"
      stroke={color}
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

BarChartSquare03Icon.propTypes = {
  color: PropTypes.string,
};

export default BarChartSquare03Icon;
